<template>
  <div class="home-page">
    <ProductSection
      :title="productTitle"
      :desc="productDesc"
      :price="productPrice"
      :link-superior-address="linkSuperiorAddress"
      @share="shareHandle"
    />
    <img src="@/assets/image/banner.jpg" style="width: 100%;margin: 20px 0;" alt="">
    <VideoSection />
  </div>
</template>

<script>
import ProductSection from "./home/components/ProductSection.vue";
import VideoSection from "./home/components/VideoSection.vue";

import {
  PRODUCT_DESC,
  PRODUCT_PRICE,
  PRODUCT_TITLE,
} from "./home/constants.js";

import { getUrlKey } from "@/utils";
import { Notify } from "vant";

export default {
  name: "HomeView",
  components: {
    ProductSection,
    VideoSection,
  },
  computed: {
    accountAddress() {
      return this.$store.state.user.accountAddress;
    },
    referralEmptyText() {
      return this.accountAddress
        ? "暂无直推用户"
        : "请先连接钱包后查看直推列表";
    },
    inviteUrl() {
      return this.$utils.buildHomeInviteUrl(this.accountAddress);
    },
  },
  data() {
    return {
      productTitle: PRODUCT_TITLE,
      productDesc: PRODUCT_DESC,
      productPrice: PRODUCT_PRICE,
      linkSuperiorAddress: "",
      sharing: false,
    };
  },
  mounted() {
    const raw = getUrlKey("address");
    this.linkSuperiorAddress = raw ? String(raw).trim() : "";
  },
  methods: {
    async shareHandle() {
      if (this.sharing) return;

      if (!this.accountAddress) {
        Notify({ type: "warning", message: "请先登录钱包" });
        return;
      }

      const url = this.inviteUrl;
      if (!url) {
        Notify({ type: "danger", message: "分享链接生成失败" });
        return;
      }

      this.sharing = true;
      try {
        const ok = await this.$utils.copyText(url);
        if (ok) {
          Notify({ type: "success", message: "已复制分享链接" });
        } else {
          Notify({
            type: "danger",
            message: "复制失败，请检查钱包浏览器剪贴板权限后重试",
          });
        }
      } finally {
        this.sharing = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100%;
  box-sizing: border-box;
  padding: 0 32px 32px;
  padding-bottom: calc(32px + env(safe-area-inset-bottom, 0px));
  color: #333;
}
</style>
